import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { withExperiments, InjectedExperimentsProps } from '@wix/wix-experiments-react';
import { ConnectedProps, connect } from 'react-redux';
import { State } from '../../../redux/configure-store';
import { TransferDialogLazyComponent } from '@wix/site-actions-service';

interface IProps extends InjectedTranslateProps, InjectedExperimentsProps, ConnectedProps<typeof connector> {
  closeModal(): void;
  isOpen: boolean;
}

class TransferOwnership extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      TransferOwnershipModal: undefined
    };
  }

  render() {
    const { locale, topology, msId, experiments, closeModal, isOpen } = this.props;
    return <div data-hook="transfer-ownership-modal"> {
      topology.siteActionsStaticsUrl &&
      <TransferDialogLazyComponent
        isOpen={isOpen}
        locale={locale}
        metaSiteId={msId}
        topology={{ siteActionsStaticsUrl: topology.siteActionsStaticsUrl }}
        debug={false}
        onOk={() => window.location.reload()}
        onRequestClose={closeModal}
        experiments={experiments}
        siteActionsStaticsUrl={topology.siteActionsStaticsUrl}
        />}
    </div>;
  }
}

const mapStateToProps = (state: State) => {
  return {
    locale: state.locale,
    msId: state.msid,
    topology: state.topology,
  };
};

const connector = connect(mapStateToProps);
export default connector(withExperiments(translate()(TransferOwnership)));
